/**
 * Loads the UtlCfg_DSTemplate layout spec. Kept apart from dsTemplateLayout.js so the PDF worker
 * can use the layout helpers without importing React or the API client.
 */
import { useEffect, useState } from 'react';
import { dsComposerApi } from '../../services/api';

let cache = null;

// The spec changes about as often as the ISA forms do, so one fetch per page load is plenty.
// A failed fetch is not cached, so the next caller retries.
//
// `fetchSpec` is the endpoint to read it from. The rows are the same whichever endpoint serves
// them; a page passes the one its own permission key reaches (the Project Composer's users may
// not hold the master composer key), so the first successful read fills the cache for everyone.
export function loadDsTemplates(fetchSpec = dsComposerApi.getTemplates) {
  if (!cache) {
    cache = fetchSpec()
      .then(res => res.data || [])
      .catch(err => { cache = null; throw err; });
  }
  return cache;
}

/** The spec rows, or null until they arrive. A failed load leaves null, which means fallback. */
export function useDsTemplates(fetchSpec) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    let live = true;
    loadDsTemplates(fetchSpec).then(r => { if (live) setRows(r); }).catch(() => {});
    return () => { live = false; };
  }, [fetchSpec]);
  return rows;
}
